import React from "react";

import { useOutletContext, useNavigate, useParams, useLocation } from 'react-router-dom';
import Service from "../../../util/Service";
import { Alert, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Snackbar, Stack, Typography } from "@mui/material";
import ColumnCard from "./ColumnCard";
import { useDrop } from 'react-dnd'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import ServiceWS, { TYPES } from "../../../util/ServiceWS";
import EscolheUserPopover from "../../page/user/EscolheUserPopover";
import MembrosAvatarGroup from "../MembrosAvatarGroup";
import ColumnOcultaMenu from "./ColumnOcultaMenu";
import ArquivadasDialog from "./ArquivadasDialog";
import { useProfile } from "../../common/useProfile";
import KanbanSyncRedmine from "./KanbanSyncRedmine";
import KanbanConfig from "./KanbanConfig";
import KanbanEtiquetas from "./KanbanEtiquetas";
import { temAcessoAoProjeto } from "../ProjetoRoot";
import { ShowWait } from "../../home/Home";
import KanbanNovoEvento from "./KanbanNovoEvento";

const style = {
    width: '1rem',
}
const DropArea = ({ index }) => {
    const [{ canDrop, isOver }, drop] = useDrop(() => ({
        accept: 'coluna',
        drop: () => ({ ordem: index }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }))
    const isActive = canDrop && isOver
    let backgroundColor = style.backgroundColor;
    if (isActive) {
        backgroundColor = 'DarkGray'
    } else if (canDrop) {
        backgroundColor = 'LightGray'
    }
    return (
        <div ref={drop} style={{ ...style, backgroundColor }} data-testid="dustbin">

        </div>
    )
}
export const PAPEIS_KANBAN_ROOT = ['portalAdm', 'rootProject', 'ProjectAdm', 'CardAdm'];
export default function KanBanRootV2() {
    const { update } = useOutletContext();
    const navigate = useNavigate();
    const prof = useProfile();
    const params = useParams();
    const location = useLocation();
    const [setting, setSetting] = React.useState();
    const [kanbans, setKanbans] = React.useState();
    const [kanban, setKanban] = React.useState();
    const [lista, setLista] = React.useState([]);
    const [projeto, setProjeto]= React.useState();
    const [openSnack, setOpenSnack]= React.useState(false);
    const [papeis, setPapeis]= React.useState();
    const [msg, setMsg]= React.useState({
        severity:'success',
        txt:'',
    });
    const [temAcessoBasico, setTemAcessoBasico] = React.useState(null);
    const [wsDado, enviaDadoWS, cleanWsDado] = ServiceWS();

    React.useEffect(() => {
        buscaProjeto();
        buscaKanban();
        buscaSetting();
        buscaPapeis();
    }, []);


    React.useEffect(() => {
        if (wsDado && wsDado.length > 0) {
            atualizaTelaViaWS();
        }
    }, [wsDado])

    React.useEffect(() => {
        if( prof.profile && projeto && papeis){
            setTemAcessoBasico(temAcessoAoProjeto(projeto, prof, papeis, PAPEIS_KANBAN_ROOT))
        }
    }, [prof.profile, projeto, papeis]);
    
    React.useEffect(() => {
        if (kanban && projeto ) {
            const arrActions = [];
            let urlVoltar = '/projeto/'+params.id;
            if( temAcessoBasico ){
                urlVoltar = "/project/pagina/"+params.id;  
            }
            arrActions.push({
                    nome: 'Voltar',
                    ac: urlVoltar
            });
            if( temAcessoBasico && kanban.idProjeto.includes("redmine_")){
                arrActions.push({
                    nome: 'Sincronizar',
                    ac: <KanbanSyncRedmine kanban={kanban} action={buscaKanban} />
                });    
            }
            if( temAcessoBasico ){
                arrActions.push({
                        nome: 'EscolheUser',
                        ac: <EscolheUserPopover membros={kanban.membros} action={handleIncluiMembro} lst={ projeto.membros} temAcessoBasico={true}/>
                });
                arrActions.push({
                    nome: 'EditarEtiqueta',
                    ac: <KanbanEtiquetas kanban={kanban} action={buscaKanban} />
                });
                arrActions.push({
                    nome: 'Novo Evento',
                    ac: <KanbanNovoEvento kanban={kanban} action={setKanban} close={handleCloseSnack}/>
                });
                arrActions.push({
                    nome: 'Configurações',
                    ac: <KanbanConfig kanban={kanban} action={setKanban} />
                });
                if( temAcessoAoProjeto(projeto, prof, papeis, ['portalAdm', 'rootProject', 'ProjectAdm', 'ArquivarCartoes']) ){
                    arrActions.push({
                            nome: 'Divider'
                    });
                    arrActions.push({
                            nome: 'Arquivadas',
                            ac: <ArquivadasDialog kanban={kanban} action={handleDesarquivar}/>
                    });
                }
            }
            
            if( setting ){
                const itens = setting.confs.filter( c => c.tipo === "colunaOculta");
                if( itens){
                    arrActions.push({
                        nome: 'Comunas ocultas',
                        ac: <ColumnOcultaMenu kanban={kanban} confs={itens} showColuna={handleShowColuna} />
                    })
                }
            }
            const comp = {
                title: {
                    variant: 'h6',
                    txt: kanban.nome
                },
                actions: arrActions,                      
            }
            if( kanban.membros && kanban.membros.length > 0 ){
                comp.membros = <MembrosAvatarGroup membros={kanban.membros} remove={handleRemoveMembro}/>
            }
            if( kanban.fundo){
                comp.fundo = kanban.fundo;
            }
            update(comp);
            buscaAllCards();
        }
    }, [kanban, projeto, temAcessoBasico]);

    function handleCloseSnack(){
        setOpenSnack(false);
    }
    function openMsg(m){
        setOpenSnack(true);
        setMsg(m);
    }
    
    function buscaProjeto(){
        Service.GET("/api/projeto/porId/" + params.id).then(r => {
            if (r) {
                setProjeto(r);
            }
        });
    }
    function buscaPapeis(){
        Service.GET('/api/security/setting/buscaByTipo/papel').then(r => setPapeis(r));
    }
    function buscaSetting(){
        Service.GET("/api/security/setting/user").then(ret => {
            if( ret.success)setSetting(ret.setting);
            else console.error( ret );
        }).catch(erro =>{
            let state;
            setTimeout(() => {
                if( typeof erro === 'string'){                    
                    state= {                        
                        status: 500,
                        statusText: erro
                    }
                }else{
                    state= {
                        status: erro.status,
                        statusText: erro.statusText,
                        url: erro.url
                    }
                }
                navigate("/erro", {
                    state: {
                        erro: state,
                        path:location.pathname
                    }
                });
            }, 1000);
            
        })
    }
    function handleShowColuna(col){
        const dado ={
            idKanban: kanban.id,
            idCol: col.idCol
        }
        Service.POST("/api/security/projeto/kanbanColumn/show", dado).then(r => {
            window.location.reload(true);
        })
    }
    function handleRemoveMembro(user) {
        const dado = {
            id: kanban.id,
            membro: user
        }
        Service.POST('/api/security/projeto/kanban/removeMembro', dado).then(r => {
            if (r.success) {
                // setKanban(r.dado);
                // buscaKanban();
                window.location.reload();
            } else {
                alert(r.msg);
            }
        })
    }
    function handleDesarquivar(dado){
        window.location.reload(true);
    }
    function handleIncluiMembro(user) {
        const dado = {
            id: kanban.id,
            membro: user
        }
        Service.POST('/api/security/projeto/kanban/incluirMembro', dado).then(r => {
            if (r.success) {
                // setKanban(r.dado);
                // buscaKanban();
                window.location.reload();
            } else {
                alert(r.msg);
            }
        })
    }
    function atualizaTelaViaWS() {
        for (let x in wsDado) {
            const item = wsDado[x];
            if (item.type === TYPES.cUpdate) {
                setKanban(item.dado);
            } else if (item.type === TYPES.cardNovo) {
                let arr = [item.dado, ...lista];
                setLista(arr);
            } else if (item.type === TYPES.cardMove) {
                moveCard(item.dado);
            } else if (item.type === TYPES.cardChangeOrdem) {
                //TODO rever, nao esta atualizando corretante os staus
                //window.location.reload(true);
                console.error('Com poblema')
            } else if (item.type === TYPES.cardMoveOutraColuna) {

                buscaKanban();
            } else if (item.type === TYPES.etiqueta) {
                buscaKanban();
            }else if (item.type === TYPES.cardMudaNome) {
                buscaKanban();
            }else if (item.type === TYPES.templateCopiado) {
                buscaKanban();
            }else if (item.type === TYPES.cardConcluido) {
                buscaKanban();
            }else if (item.type === TYPES.cardArquivar) {   
                buscaKanban();
            }else {
                buscaKanban();
            }
        }
        cleanWsDado();
    }
    function moveCardAPI(item) {

        {
            const dado = item;
            Service.POST('/api/security/projeto/kanban/moverCard', dado).then(r => {
            })
        }
    }

    function moveCard(item) {
        let arr = [...lista];
        for (let x = 0; x < item.length; x++) {
            let c = arr.find(i => i.id === item[x].id);
            c.ordem = item[x].ordem;
        }
        setLista(arr);
    }
    function buscaAllCards() {
        Service.GET("/api/projeto/kanban/cards/" + kanban.id).then(r => {
            setLista(r);
        });
    }
    function buscaKanban() {
        const idKanban = params.idKanban;
        Service.GET("/api/projeto/kanbans/" + params.id).then(r => {
            if (r) {
                setKanbans(r);
                if (idKanban) {
                    const item = r.find(i => i.id === idKanban);
                    setKanban(item ? item : r[0]);
                } else {
                    r.length === 1 ? setKanban(r[0]) : setKanban();
                }
                if (!idKanban && r.length === 1) {
                    const path = location.pathname;
                    navigate(path + '/' + r[0].id);
                }
            }
        });
    }

    function handleUpdateOrdem(source, target) {

        if (source.ordem === target.ordem) return;
        let dado = { ...kanban };
        let arr = dado.colunas;
        
        if (source.ordem > target.ordem) {
            let dif = source.ordem - (target.ordem + 1);
            if (dif > 1) {
                for (let x = 0; x < dif && dif > 1; x++) {
                    let i = target.ordem + x;
                    arr[i].ordem = arr[i].ordem + 1;
                }
                arr[source.ordem - 1].ordem = target.ordem + 1;
            } else {
                arr[source.ordem - 2].ordem = source.ordem;
                arr[source.ordem - 1].ordem = source.ordem - 1;
            }
            // 
        } else {
            let dif = target.ordem - source.ordem;
            for (let x = 0; x < dif; x++) {
                let i = source.ordem + x;
                arr[i].ordem = arr[i].ordem - 1
            }
            arr[source.ordem - 1].ordem = target.ordem;
            // arr[target.ordem - 1].ordem = target.ordem - 1;
        }
        arr.sort((a, b) => a.ordem - b.ordem);
        dado.colunas = arr;

        Service.POST('/api/projeto/kanbans', dado).then(r => {
            setKanban(dado);
            enviaDadoWS({ dado, type: TYPES.cUpdate });
        })
    }
    function handleUpdateColumn(k) {
        if (k.type === TYPES.cUpdate) {
            setKanban(k.dado);
        } else if (k.type === TYPES.cardMove) {
            moveCardAPI(k.dado);
        } else if (k.type === TYPES.cardChangeOrdem) {
            // moverOrdemCard(k.source, k.target);
            return;
        } else if (k.type === TYPES.cardMoveOutraColuna) {
            updateCardOutraColuna(k.dado);
            atualizaKanban();
        } else if (k.type === TYPES.etiqueta) {
            atualizaKanban();
        }else if (k.type === TYPES.MudaNomeCartao) {
            //atualizaKanban();
        }else if (k.type === TYPES.templateCopiado) {
            atualizaKanban();
        }else if (k.type === TYPES.cardConcluido) {
            atualizaKanban();
        }else {
            atualizaKanban();
        }
        enviaDadoWS({ dado: k.dado, type: k.type });
    }
    function atualizaKanban() {
        const idKanban = params.idKanban;
        Service.GET("/api/projeto/kanban/" + idKanban).then(r => {
            setKanban(r);
        });
    }
    function updateCardOutraColuna(card) {
        const dado = {
            id: card.id,
            idColuna: card.idColuna,
            ordem: 0
        }
        Service.POST('/api/security/projeto/kanban/moverCardColuna', dado).then(r => {

        })
    }

    if( !prof.profile || !papeis || !projeto || !kanban)return(
        <ShowWait />
    )
    return (
        <DndProvider backend={HTML5Backend}>
            <Stack direction="row" spacing={0} >
                {kanban && kanban.colunas.map((row, index) =>{
                    if( row.regra ){
                        if( !prof.temAcesso(row.regra)){
                            return;
                        }
                    }
                    if(setting ){
                        const item = setting.confs.find( c => c.idKanban === kanban.id && c.idCol === row.id)
                        if( item && item.tipo === "colunaOculta") return;
                    }
                    return (
                    <React.Fragment key={row.id}>
                        <DropArea index={index} />
                        <ColumnCard
                            col={row}
                            atualizaCol={handleUpdateOrdem}
                            action={handleUpdateColumn}
                            kanban={kanban} lista={lista}
                            setLista={setLista}
                            TYPES={TYPES}
                            openMsg={openMsg}
                            projeto={projeto}
                            papeis={papeis}
                            temAcessoBasico={temAcessoBasico}
                        />
                    </React.Fragment>)
                    })}
                {kanban && <DropArea index={kanban.colunas.length} />}
            </Stack>
            {!kanban && kanbans && kanbans.length > 1 &&
                <div>
                    <Typography variant="h5"> Escolha qual kanban:</Typography>
                    <List>
                        {kanbans.map((row, id) =>
                            <ListItem key={id} disablePadding>
                                <ListItemButton href={"/project/kanban/"+params.id+"/"+row.id}>
                                    <ListItemText primary={row.nome} />
                                </ListItemButton>
                            </ListItem>
                        )}
                    </List>
                </div>

            }
            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity={msg.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg.txt}
                </Alert>
            </Snackbar>
        </DndProvider>
    )
}

// export default KanBanRoot;

